








import { Component, Vue } from "vue-property-decorator";
import LangusgeSwitcher from "@/components/app/LangusgeSwitcher.vue";
@Component({
  name: "empty-layout",
  components: {
    LangusgeSwitcher,
  },
})
export default class EmptyLayout extends Vue {}
